import React from 'react';
import { twMerge } from 'tailwind-merge';

import { TbArrowRight } from 'react-icons/tb';

import Icon from 'components-new/icon/icon';
import Typography from 'components-new/typography/typography';

import type { RouteType } from '.';

interface SideBarElementProps {
  route: RouteType;
}
const SideBarElement: React.FC<SideBarElementProps> = ({ route }) => {
  return (
    <li key={route.id}>
      <a
        href={route.src}
        className={twMerge(
          'flex gap-2 items-center px-3 py-1.5 text-gray500 rounded-lg hover:bg-gray50 hover:text-primary-500',
          route.isSelected && 'bg-gray50 text-primary-400',
        )}
      >
        <Icon icon={route.icon} />
        <Typography as="span" variant="body-medium" className="flex-1">
          {route.label}
        </Typography>
        <Icon icon={TbArrowRight} size={20} className="md:hidden" />
      </a>
    </li>
  );
};
export default SideBarElement;
